import { createApp } from 'vue'
import App from './apps/isigma-locator/LocatorApp.vue'

createApp(App).mount('#locator-app')
